module.exports = __webpack_public_path__ + "static/media/382GriffinStNW_2018-06-05_47.5d3946bf.jpg";